import type { SearchResponse } from '@algolia/client-search';

import type { ApiUnpublishedEvent } from 'modules/listing/api/event/types/ApiUnpublishedEvent';
import type { ApiUnpublishedInternship } from 'modules/listing/api/internship/types/ApiUnpublishedInternship';
import type { ApiUnpublishedVolop } from 'modules/listing/api/volop/types/ApiUnpublishedVolop';
import { searchAlgoliaOptionsLocationData } from 'modules/search/algolia/options/searchAlgoliaOptionsLocationData';
import { searchAlgoliaConfig } from 'modules/search/algolia/searchAlgoliaConfig';
import { searchAlgoliaIndex } from 'modules/search/algolia/searchAlgoliaIndex';
import { searchAlgoliaVolopsIndex } from 'modules/search/algolia/searchAlgoliaVolopsIndex';
import type { SearchAlgoliaRecommendedListingHit } from 'modules/search/algolia/types/SearchAlgoliaRecommendedListingHit';
import { algoliaSearch } from 'utils/algolia/algoliaSearch';

export function searchAlgoliaFetchRecommendedListings(
  unpublishedListing:
    | ApiUnpublishedInternship
    | ApiUnpublishedVolop
    | ApiUnpublishedEvent,
): Promise<SearchResponse<SearchAlgoliaRecommendedListingHit>> {
  const { address, remoteOptions } = unpublishedListing;

  const locationData =
    remoteOptions.locationType === 'ONSITE'
      ? searchAlgoliaOptionsLocationData('', {
          latitude: address.latitude,
          longitude: address.longitude,
        })
      : undefined;

  const locationFilters = locationData?.locationFilters ?? [
    `(locationType:'${remoteOptions.locationType}')`,
  ];

  const typeFilters = [];
  if (unpublishedListing.type === 'UNPUBLISHED_INTERNSHIP')
    typeFilters.push(["type:'INTERNSHIP'"]);
  if (unpublishedListing.type === 'UNPUBLISHED_EVENT')
    typeFilters.push(["type:'EVENT'"]);

  return algoliaSearch<SearchAlgoliaRecommendedListingHit>({
    config: searchAlgoliaConfig(),
    query: '',
    indexName:
      unpublishedListing.type === 'UNPUBLISHED_VOLOP'
        ? searchAlgoliaVolopsIndex({ actionDate: null, sort: 'newest' })
        : searchAlgoliaIndex('newest'),
    options: {
      filters: [...locationFilters, ...typeFilters].join(' AND '),
      ...locationData?.locationOptions,
      hitsPerPage: 8,
    },
  });
}
